import { render, staticRenderFns } from "./HomeBlackSVG.vue?vue&type=template&id=3a4d9e66&"
import script from "./HomeBlackSVG.vue?vue&type=script&lang=js&"
export * from "./HomeBlackSVG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports